import { Label } from "./Label";
import { ManualMeasurement } from "./ManualMeasurement";
import { PatientNote } from "./PatientNote";

export enum ObjectiveType {
    PatientNote,
    DeviceMeasurement,
    ManualMeasurement,
    Label
}

export class Objective {
    type: ObjectiveType | null = null;
    objective: ManualMeasurement | PatientNote | Label | null = null;
    time: Date | null = null;

    constructor(init?: Partial<Objective>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.type === ObjectiveType.ManualMeasurement) {
            this.objective = new ManualMeasurement(init.objective as ManualMeasurement);
        }

        if (init.type === ObjectiveType.PatientNote) {
            this.objective = new PatientNote(init.objective as PatientNote);
        }

        if (init.type === ObjectiveType.Label) {
            this.objective = new Label(init.objective as Label);
        }

        if (init.time) {
            this.time = new Date(init.time);
        }
    }
}
